import { SvgIcon, SvgIconProps } from '@mui/material';

export const ServiceClientIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 12 12"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      {...props}
    >
      <path d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6Z" />
      <path d="M10 6C10 8.20914 8.20914 10 6 10C3.79086 10 2 8.20914 2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6Z" />
    </SvgIcon>
  );
};

export const ProposalLostIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 12 12"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      {...props}
    >
      <path
        d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6Z"
        fill="#B1B1B2"
      />
    </SvgIcon>
  );
};

export const ProposalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 12 12"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      {...props}
    >
      <path d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6Z" />
      <path d="M9.45906 8.0087C9.81174 7.40139 9.9983 6.71192 9.99999 6.00964C10.0017 5.30735 9.81844 4.617 9.4687 4.00799C9.11896 3.39898 8.61504 2.89279 8.00762 2.54031C7.40019 2.18782 6.71067 2.00148 6.00838 2.00001L6 6L9.45906 8.0087Z" />
    </SvgIcon>
  );
};

export const ActiveProjectIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 18 18"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      {...props}
    >
      <path d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9Z" />
      <path d="M9 3C10.0532 3 11.0879 3.27724 12 3.80386C12.9121 4.33047 13.6696 5.0879 14.1962 6.00003C14.7228 6.91215 15 7.94677 15 9C15 10.0532 14.7227 11.0879 14.1961 12.0001C13.6695 12.9122 12.9121 13.6696 11.9999 14.1962C11.0878 14.7228 10.0531 15 8.99991 15C7.94668 15 6.91202 14.7227 5.99991 14.1961C5.0878 13.6695 4.33044 12.9121 3.80385 12L9 9V3Z" />
    </SvgIcon>
  );
};
